import React, { useState, useEffect, useCallback } from 'react';
import { getData, updateData } from '../../services/venueServices';
import { Button, Form } from 'react-bootstrap';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import { validateFile} from '../../utils/validators';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';
import { isQuillContentEmpty } from '../../utils/common';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const Venue = () => {
  
  const [formData, setFormData] = useState({
    id: null,
    uploadedfile: null,
    venue_heading: '',
    about_venue: '',
    venue_map: '',
  });
  const [loading, setLoading] = useState(false);  
  const [errors, setErrors] = useState({}); 

  // Fetch data from API
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
    const response = await getData();
    if (response.data.length > 0) {
      setFormData(response.data[0]); // Load first record into the form
    }
  }
  catch (error) { 
          console.error('Error fetching data:', error);
        }
  finally {
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Validate form data
      const validateForm = () => {
      const newErrors = {};
      if (!formData.venue_heading) newErrors.venue_heading = "Hotel/ Venue Details is required";
      if (!formData.venue_map) newErrors.venue_map = "Embedded Map Snippet is required";
      if (!formData.about_venue) newErrors.about_venue = "About Venue is required";
      // if (!formData.uploadedfile && formData.uploadedfile === null) {
      // if (!errors.uploadedfile) newErrors.uploadedfile = "Hotel/ Venue Image is required";
      //   }
      setErrors((prev) => ({ ...prev, ...newErrors }));
      return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);  
    }



  // Handle input changes
  const handleChange = async(e) => {
    try{
      const { name, value, files } = e.target;
      const file = files?.[0]
        // Create a copy of the current form data
        let updatedData = { ...formData };
        let updatedErrors = { ...errors };
        if (file) {
            const fileType = file.type.includes("image") ? "img" : "pdf";
            const isValid = await validateFile(file, setErrors,name,fileType);
            if (isValid) {
              updatedData[name] = file;
              updatedErrors[name] = '';
            }
            else{
              return ; // Don't update if invalid
            }
      } 
        else{
        updatedData[name] = value;
        if (value) {
        updatedErrors[name] = ''; // Clear error if corrected
      }}
      setFormData(updatedData);
      setErrors(updatedErrors);
    }
      catch (error) {
      console.error("Error in handleChange:", error);
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
        return
      }
    try{
    const form = new FormData();
    form.append('id', formData?.id);
    form.append('venue_heading', formData?.venue_heading);
    form.append('about_venue', formData?.about_venue);
    form.append('venue_map', formData?.venue_map);
    form.append('uploadedfile', formData?.uploadedfile);
  
    const result = await updateData(form);
    if (result.status === 200) {
      fetchData(); // Refresh data after update
      toast.success("Updated Successfully!", {position: 'top-right',autoClose: 3000});
    } else {
      toast.error(result.message ||"Failed to Added data. Please try again.", {position: 'top-right',autoClose: 3000});
    }
  }
  catch (error) {
          console.error("Error during form submission:", error);
      }
  };

 // Handle change for Quill editor
  const handleAboutVenueChange = (value) => {
    setErrors((prev) => ({ ...prev, about_venue: isQuillContentEmpty(value) ? 'About Venue is required' : '' }));
    setFormData((prev) => ({ ...prev, about_venue: value }));
  };

    const modules = {
    toolbar: [
      // Font family and size
      [{ 'font': [] }, { 'size': ['small', false, 'large', 'huge'] }],

      // Headings
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

      // Text styles
      ['bold', 'italic', 'underline', 'strike'],

      // Subscript / Superscript
      [{ 'script': 'sub' }, { 'script': 'super' }],

      // Blockquote and code block
      ['blockquote', 'code-block'],

      // Color and background
      [{ 'color': [] }, { 'background': [] }],

      // Text alignment and direction (RTL)
      [{ 'align': [] }, { 'direction': 'rtl' }],

      // Ordered / bullet list
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],

      // Indent and outdent
      [{ 'indent': '-1' }, { 'indent': '+1' }],

        ['link'],

      // Clear formatting
      ['clean']
    ]
  };
    
  const formats = [
    'font', 'size',
    'header',
    'bold', 'italic', 'underline', 'strike',
    'script',
    'blockquote', 'code-block',
    'color', 'background',
    'align', 'direction',
    'list', 'bullet', 'indent',
    'link', 'image', 'video',
  ];


  useEffect(() => {
      const tooltipMap = {
        'ql-bold': 'Bold',
        'ql-italic': 'Italic',
        'ql-underline': 'Underline',
        'ql-strike': 'Strikethrough',
        'ql-script[value="sub"]': 'Subscript',
        'ql-script[value="super"]': 'Superscript',
        'ql-blockquote': 'Blockquote',
        'ql-code-block': 'Code Block',
        'ql-color': 'Text Color',
        'ql-background': 'Background Color',
        'ql-align': 'Align',
        'ql-direction': 'Text Direction',
        'ql-list[value="ordered"]': 'Ordered List',
        'ql-list[value="bullet"]': 'Bullet List',
        'ql-indent[value="-1"]': 'Outdent',
        'ql-indent[value="+1"]': 'Indent',
        'ql-link': 'Insert Link',
        'ql-clean': 'Clear Formatting',
      };

    const setTooltips = () => {
      Object.entries(tooltipMap).forEach(([selector, title]) => {
        const el = document.querySelector(`.ql-toolbar .ql-formats .${selector}`);
        if (el && !el.title) {
          el.setAttribute('title', title);
        }
      });
    };

    const observer = new MutationObserver((mutations, obs) => {
      const toolbarReady = document.querySelector('.ql-toolbar');
      if (toolbarReady) {
        setTooltips();
        obs.disconnect(); // Stop observing once done
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

  return () => observer.disconnect() // Clean up on unmount
  }, []);

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className='mb-3 fs-4'>Other Pages <b>/ Venue</b></p>
            </div>
            <div className="col-4 text-end">
              {/* <button className="btn btn-primary mb-3" onClick={() => openModal('add')}>
                Add
              </button> */}
            </div>
          </div>
          {/* <h1 className="mb-4">Venue</h1> */}

          {/* Editable Form (Always Visible) */}
          <div className="card p-3 mb-4">
            <Form onSubmit={handleSubmit}>
            <div className="row">
              <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>Hotel/ Venue Details <small className='text-danger'>*</small></Form.Label>
              <Form.Control
                  type="text"
                  name="venue_heading"
                  value={formData.venue_heading}
                  onChange={handleChange}
                  isInvalid = {!!errors.venue_heading}
                />
              <Form.Control.Feedback type="invalid">{errors.venue_heading}</Form.Control.Feedback>
                
              </Form.Group>
              <Form.Group className="col-md-6 mb-3">
                <Form.Label className='form-label-custom'>Hotel/ Venue Image  <small className='text-primary'> (Dimension:250x250 | Size:15kb to 60kb)</small></Form.Label>
                <Form.Control type="file" name="uploadedfile" onChange={handleChange} isInvalid = {!!errors.uploadedfile} />
              <Form.Control.Feedback type="invalid">{errors.uploadedfile}</Form.Control.Feedback>

                {formData.uploadedfile && typeof formData.uploadedfile === 'string' && (
                  <p>
                    <a href={formData.uploadedfile} target="_blank" rel="noopener noreferrer">
                      View Current File
                    </a>
                  </p>
                )}
              </Form.Group>

              <Form.Group className="col-md-6 mb-3">
                <Form.Label className='form-label-custom'>Embedded Map Snippet <small className='text-danger'>*</small> </Form.Label>
                <Form.Control
                  type="text"
                  name="venue_map"
                  value={formData.venue_map}
                  onChange={handleChange}
                  isInvalid = {!!errors.venue_map}
                />
              <Form.Control.Feedback type="invalid">{errors.venue_map}</Form.Control.Feedback>
                
              </Form.Group>
              
                                       
              <Form.Group className="col-md-12 mb-3">
              <Form.Label className='form-label-custom'>About Venue <small className='text-danger'>*</small></Form.Label>
              <ReactQuill
                value={formData.about_venue}
                onChange={handleAboutVenueChange}
                theme="snow"
                modules={modules}
                formats={formats}
                placeholder="Enter about Venue"
                className={`react-quill-editor ${errors.about_venue ? 'border border border-1 border-danger rounded' : ''}`}
            />
            {errors.about_venue && (
                <div className="invalid-feedback d-block">
                  {errors.about_venue}
                </div>
              )}
              </Form.Group>
                
                {/* <Form.Control
                  as="textarea"
                  rows={8} 
                  name="about_venue"
                  value={formData.about_venue}
                  onChange={handleChange}
                  isInvalid = {!!errors.about_venue}
                />
              <Form.Control.Feedback type="invalid">{errors.about_venue}</Form.Control.Feedback> */}
                
              <Form.Group className="col-md-6 mb-3">
                <Form.Label className='form-label-custom'>Hotel/ Venue Image Preview </Form.Label>
                {formData.venue_img && (
                  <div style={{width:'200px',height:'150px'}}>
                    <img height='100%' width='100%' src={formData.venue_img} alt="Hotel venue" 
                    style={{objectFit: 'cover',borderRadius: '5px'}}
                    crossOrigin="anonymous" 
                    />
                    </div>
                )}
                </Form.Group>
                       
              </div>
              <Button variant="success" type="submit">Submit</Button>
            </Form>
          </div>
        </div>
        <Footer />
        </div>
      )}
      </div>
    </div>
  );
};

export default Venue;
